import React from 'react';
import styles from './ProposalColumn.module.css';

/**
 * Bloc Puck — Colonne issue du proposal.
 * La largeur est calculée en pourcentage à partir du span (1-12).
 */
const ProposalColumn = ({ id, span = 12, blocks = [] }) => {
  const widthPct = `${(span / 12) * 100}%`;

  return (
    <div
      id={id}
      className={styles.column}
      style={{ width: widthPct, maxWidth: widthPct }}
    >
      {blocks}
    </div>
  );
};

export default ProposalColumn;
